<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: [],
      geocoder: null,
      debounceTimer: null,
      requestSeq: 0
    };
  },

  created() {
    GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
    });
  },

  beforeDestroy() {
    // Timer und laufende Anfrage beim Zerstoeren beenden.
    if (this.debounceTimer != null) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = null;
    }
    if (this.geocoder) {
      this.geocoder.cancelAutocomplete();
    }
    // Verspaetete Antworten invalidieren.
    this.requestSeq++;
  },

  watch: {
    search(val) {
      if (val && val !== this.select) {
        this.querySelections(val);
      } else {
        // Leere Eingabe: Timer und Anfrage beenden, Treffer verwerfen.
        this.cancelPending();
        this.items = [];
        this.loading = false;
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    cancelPending() {
      if (this.debounceTimer != null) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
      // Bisherige und verspaetete Antworten invalidieren.
      this.requestSeq++;
    },

    querySelections(value) {
      if (!this.geocoder) {
        return;
      }

      this.loading = true;

      this.cancelPending();
      const seq = this.requestSeq;

      this.debounceTimer = setTimeout(() => {
        this.debounceTimer = null;
        this.geocoder.autocomplete(value).then(items => {
          // Nur die juengste Anfrage darf Treffer und Ladezustand setzen.
          if (seq !== this.requestSeq) {
            return;
          }
          this.items = items.slice();
          this.loading = false;
        }).catch(() => {
          if (seq !== this.requestSeq) {
            return;
          }
          this.loading = false;
        });
      }, 150);
    },

    change(o) {
      this.$emit("change", o);
    }
  }
};
</script>
